module.exports = __webpack_public_path__ + "static/media/illustration-element-01.9a0463e0.svg";